export const dateKey = (date) => date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : '';

export function asDate(value) {
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
    if (!value) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;
    const [, year, month, day] = match.map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}

export const inBounds = (date, min, max) => (!min || date >= min) && (!max || date <= max);
export const clampDate = (date, min, max) => min && date < min ? min : max && date > max ? max : date;
export function shiftMonth(date, count) {
    const target = new Date(date.getFullYear(), date.getMonth() + count, 1);
    return new Date(target.getFullYear(), target.getMonth(), Math.min(date.getDate(), new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate()));
}
export const displayDate = (date) => date?.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) || '';
export const fullDate = (date) => date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
